import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="w-full bg-white shadow-sm fixed top-0 left-0 z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
        <Link to="/" className="text-xl font-bold text-blue-700 hover:text-blue-900 transition">KORA</Link>
        <ul className="hidden md:flex gap-8 items-center text-blue-900 font-medium">
          <li><Link to="/features" className="hover:text-blue-600 transition">Aperçu</Link></li>
          <li><Link to="/pricing" className="hover:text-blue-600 transition">Tarifs</Link></li>
          <li><Link to="/contact" className="hover:text-blue-600 transition">Contact</Link></li>
        </ul>
        <button className="ml-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-2 rounded-lg shadow font-semibold hover:from-blue-600 hover:to-purple-600 transition">Créer mon compte</button>
      </div>
    </nav>
  );
}

export default Navbar; 